import { render } from "./UserInfo.vue?vue&type=template&id=1dbd3c10&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=1dbd3c10&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbd3c10"]])

export default __exports__